var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/MainCategoryEnums';
let MainCategoryModule = class MainCategoryModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.mainCategoryList = [];
        this.mainCategoryCode = [];
        this.mainCategoryDesc = [];
        this.selectedCategoryCode = [];
        this.selectedCategoryDesc = [];
        this.isActive = true;
        this.useFilter = true;
        this.mainCategoryPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.status = '';
        this.statusMessage = '';
        this.searchBy = '';
    }
    get getMainCategoryWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getMainCategoryLoading() {
        return this.loading;
    }
    get getMainCategoryDataList() {
        return this.mainCategoryList;
    }
    get getMainCategoryListCode() {
        return this.mainCategoryCode;
    }
    get getMainCategoryListDesc() {
        return this.mainCategoryDesc;
    }
    get getMainCategorySelectedCode() {
        return this.selectedCategoryCode;
    }
    get getMainCategorySelectedDesc() {
        return this.selectedCategoryDesc;
    }
    get getMainCategoryActive() {
        return this.isActive;
    }
    get getMainCategoryPaging() {
        return this.mainCategoryPaging;
    }
    get getMainCategorySize() {
        return this.size;
    }
    get getMainCategoryStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getMainCategoryUseFilter() {
        return this.useFilter;
    }
    get getMainCategoryWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getMainCategoryDesc() {
        return this.desc;
    }
    get getMainCategorySearchKey() {
        return this.desc;
    }
    get getMainCategorySearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_MAIN_CATEGORY_WAS_FIRST_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_MAIN_CATEGORY_LOADING](payload) {
        this.loading = payload;
    }
    [_c = Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_d = Mutations.SET_MAIN_CATEGORY_LIST](payload) {
        this.mainCategoryList = payload;
    }
    [_e = Mutations.SET_MAIN_CATEGORY_LIST_CODE](payload) {
        this.mainCategoryCode = payload;
    }
    [_f = Mutations.SET_MAIN_CATEGORY_LIST_DESC](payload) {
        this.mainCategoryDesc = payload;
    }
    [_g = Mutations.SET_SELECTED_MAIN_CATEGORY_CODE](payload) {
        this.selectedCategoryCode = payload;
    }
    [_h = Mutations.SET_SELECTED_MAIN_CATEGORY_DESC](payload) {
        this.selectedCategoryDesc = payload;
    }
    [_j = Mutations.SET_SELECTED_MAIN_CATEGORY_ACTIVE](payload) {
        this.isActive = payload;
    }
    [_k = Mutations.SET_MAIN_CATEGORY_PAGE](payload) {
        this.mainCategoryPaging = payload;
    }
    [_l = Mutations.SET_MAIN_CATEGORY_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_m = Mutations.SET_MAIN_CATEGORY_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_o = Mutations.SET_MAIN_CATEGORY_SIZE](payload) {
        this.size = payload;
    }
    [_p = Mutations.SET_MAIN_CATEGORY_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_q = Mutations.SET_MAIN_CATEGORY_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_r = Mutations.SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_s = Mutations.SET_MAIN_CATEGORY_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_t = Mutations.SET_MAIN_CATEGORY_SEARCH_KEY](payload) {
        this.desc = payload;
    }
    [_u = Actions.GET_MAIN_CATEGORY_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAIN_CATEGORY_LOADING, true);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/maincategory/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                page: this.pageFilter.toString(),
                size: this.size.toString(),
                desc: this.desc,
                searchBy: this.searchBy,
                selectedCategoryCode: [],
                mainCategoryDesc: [],
                isActive: this.isActive
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST, res.data.result.content.data);
                            this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE, res.data.result.content.paging);
                        }
                        else {
                            this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST, res.data.result.content);
                            this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE, {
                                currentPage: 0,
                                totalPages: 0,
                                totalElements: 0,
                                errorRows: 0,
                                readyToUpload: 0
                            });
                        }
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAIN_CATEGORY_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_v = Actions.GET_MAIN_CATEGORY_LIST_CODE_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/maincategory/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                page: this.pageFilter.toString(),
                size: this.size.toString(),
                desc: this.desc,
                searchBy: this.searchBy,
                selectedCategoryCode: [],
                mainCategoryDesc: [],
                isActive: this.isActive
            };
            const dataCode = [...this.mainCategoryCode];
            const dataDesc = [...this.mainCategoryDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataCode.push({
                                    value: data.mainCategoryCode,
                                    label: data.mainCategoryCode
                                });
                                dataDesc.push({
                                    value: data.mainCategoryDesc,
                                    label: data.mainCategoryDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_CODE, dataCode);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_MAIN_CATEGORY_WAS_LOAD_QUICK_FILTER, true);
                    reject(false);
                });
            });
        });
    }
    [_w = Actions.CREATE_MAIN_CATEGORY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/maincategory?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_CODE, []);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_DESC, []);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_MAIN_CATEGORY_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_x = Actions.UPDATE_MAIN_CATEGORY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/maincategory?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_CODE, []);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_DESC, []);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_MAIN_CATEGORY_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_y = Actions.GET_MAIN_CATEGORY_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_CODE, data.mainCategoryCode);
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_DESC, data.mainCategoryDesc);
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_ACTIVE, data.isActive);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/maincategory/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                page: this.page.toString(),
                size: this.size.toString(),
                desc: '',
                searchBy: this.searchBy,
                mainCategoryCode: data.mainCategoryCode,
                mainCategoryDesc: data.mainCategoryDesc,
                isActive: data.isActive
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _9, _10, _11;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST, ((_9 = res.data.result.content) === null || _9 === void 0 ? void 0 : _9.data) || []);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_MAIN_CATEGORY_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE, ((_10 = res.data.result.content) === null || _10 === void 0 ? void 0 : _10.paging) || {
                                currentPage: 0,
                                totalPages: 0,
                                totalElements: 0,
                                errorRows: 0,
                                readyToUpload: 0
                            });
                        }
                        this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE, ((_11 = res.data.result.content) === null || _11 === void 0 ? void 0 : _11.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_z = Actions.DOWNLOAD_MAIN_CATEGORY]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/maincategory/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    mainCategoryCode: this.selectedCategoryCode,
                    mainCategoryDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_0 = Actions.UPDATE_MAIN_CATEGORY_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_1 = Actions.GET_MAIN_CATEGORY_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST_FILTER, {
                    mainCategoryCode: this.selectedCategoryCode,
                    mainCategoryDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                });
            }
        });
    }
    [_2 = Actions.UPDATE_SELECTED_MAIN_CATEGORY_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_CODE, data);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_DATA);
        });
    }
    [_3 = Actions.UPDATE_SELECTED_MAIN_CATEGORY_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_DESC, data);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_DATA);
        });
    }
    [_4 = Actions.UPDATE_SELECTED_MAIN_CATEGORY_ACTIVE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_ACTIVE, data);
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_DESC, []);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_DATA);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST_CODE_DESC);
        });
    }
    [_5 = Actions.UPDATE_MAIN_CATEGORY_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAIN_CATEGORY_SIZE, data);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_DATA);
        });
    }
    [_6 = Actions.RESET_MAIN_CATEGORY_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_MAIN_CATEGORY_ACTIVE, true);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_DATA);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST_CODE_DESC);
        });
    }
    [_7 = Actions.UPDATE_SEARCH_MAIN_CATEGORY_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAIN_CATEGORY_SEARCH_BY, 'MainCategoryDesc');
            this.context.commit(Mutations.SET_MAIN_CATEGORY_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_DESC, []);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST_CODE_DESC);
        });
    }
    [_8 = Actions.UPDATE_SEARCH_MAIN_CATEGORY_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_MAIN_CATEGORY_SEARCH_BY, 'MainCategoryCode');
            this.context.commit(Mutations.SET_MAIN_CATEGORY_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_MAIN_CATEGORY_LIST_CODE, []);
            this.context.dispatch(Actions.GET_MAIN_CATEGORY_LIST_CODE_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MainCategoryModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _x, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _y, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _z, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _0, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _1, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _2, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _3, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _4, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _5, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _6, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _7, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], MainCategoryModule.prototype, _8, null);
MainCategoryModule = __decorate([
    Module
], MainCategoryModule);
export default MainCategoryModule;
